import React, { useState } from "react";
import Modal from "../../../../components/Reusable/Modal";
import { useAppDispatch } from "../../../../hooks/hooks";
import { toast } from "react-toastify";
import { DeleteModalProps } from "../types";
import {
  deleteCablePlan,
  fetchCablePlans,
} from "../../../../features/auth/store/cablePlanSlice";

export const DeleteCableModal: React.FC<DeleteModalProps> = ({
  id: cablePlanId,
  isOpen,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (cablePlanId === null) return;
    setIsSubmitting(true);
    try {
      await dispatch(deleteCablePlan(cablePlanId)).unwrap();
      toast.success("Cable Plan deleted successfully! 🚀");
      onClose();
      dispatch(fetchCablePlans({}));
    } catch (err: any) {
      toast.error(err?.message || "Failed to delete plan");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-xl font-bold mb-4">Delete Cable Plan</h2>
      <div className="p-4">
        <p>Are you sure you want to delete this cable Plan?</p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
